import React from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { PixelSpinner } from 'pixel-base'
import { env } from 'shared/env'

import { post } from 'utils/api-routes.util'

import CheckoutForm from './CheckoutForm'

interface AddStripeBillingPaymentMethodProps {
  handleClose: () => void
}

const AddStripeBillingPaymentMethod: React.FC<
  AddStripeBillingPaymentMethodProps
> = ({ handleClose }) => {
  const [clientSecret, setClientSecret] = React.useState()
  const [showSpinner, setShowSpinner] = React.useState(true)
  const key = env.STRIPE_PUBLISHABLE_KEY
  const stripePromise = loadStripe(key)
  React.useEffect(() => {
    post('/settings/billing/payment-method', undefined).subscribe((res) => {
      if (res?.response?.data && res?.response?.data?.id) {
        setClientSecret(res?.response?.data?.client_secret)
        setShowSpinner(false)
      } else {
        handleClose(res?.response)
      }
    })
  }, [])

  return (
    <div
      style={
        !clientSecret
          ? {
              position: 'relative',
              height: 'auto',
              minHeight: '35%',
            }
          : {
              position: 'relative',
              height: 'auto',
            }
      }
    >
      {clientSecret ? (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm handleClose={handleClose} />
        </Elements>
      ) : (
        <PixelSpinner isShow={showSpinner} />
      )}
    </div>
  )
}

export default AddStripeBillingPaymentMethod
